import { PixPayoutDestinationDetails } from '@lib/types/finance';

import { maskBRCNPJ, maskBRCPF, maskBRPhone } from './masks';

type PixKeyType = PixPayoutDestinationDetails['pixKeyType'];

export const normalizePixKey = (value: string, type?: PixKeyType): string => {
  const trimmed = value.trim();

  if (type === 'document') {
    return trimmed.replace(/\D/g, '');
  }

  if (type === 'phone') {
    const digits = trimmed.replace(/\D/g, '');

    return trimmed.startsWith('+') ? `+${digits}` : `+55${digits}`;
  }

  return trimmed;
};

export const maskPixKey = (value: string, type?: PixKeyType): string => {
  if (type === 'document') {
    return value.replace(/\D/g, '').length > 11 ? maskBRCNPJ(value) : maskBRCPF(value);
  }

  if (type === 'phone') {
    return value.trim().startsWith('+') ? `+${value.replace(/\D/g, '').slice(0, 15)}` : maskBRPhone(value);
  }

  return value;
};
